(function () {
  if (window.CDCleerCollectionImageBanner) return;

  function ready(section) {
    if (!section) return;
    section.classList.add('is-visible');
  }

  function init(context) {
    var sections = (context || document).querySelectorAll('[data-cd-ci-banner]');
    if (!sections.length) return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      sections.forEach(ready);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          ready(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.26,
      rootMargin: '0px 0px -8% 0px'
    });

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });

  window.CDCleerCollectionImageBanner = { init: init };
})();
